import { ExpansionPanel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

interface AccordionProps {
  disableRootStyles?: boolean;
}

const Accordion = withStyles(theme => ({
  root: (props: AccordionProps) =>
    (props.disableRootStyles ?? false)
      ? {}
      : {
          boxShadow: 'none',
          backgroundColor: theme.palette.common.gray100,
          paddingBottom: theme.spacing(1),

          '&:before': {
            display: 'none',
          },
          '&$expanded': {
            margin: 'auto',
          },
        },
  expanded: {},
}))(ExpansionPanel);

Accordion.defaultProps = {
  disableRootStyles: false,
};

export default Accordion;
